import {useState, type PropsWithChildren, useEffect} from 'react';
import {clsx} from 'clsx';
import {jsCompanyInformationId} from '../lib/const';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './root.module.css';

type Props = PropsWithChildren & {
  readonly isPreview?: boolean;
};

export function PressReleaseHeaderRoot({children, isPreview = false}: Props) {
  const [isFolded, setIsFolded] = useState(false);

  useEffect(() => {
    const companyInformation = document.querySelector<HTMLDivElement>(
      `#${jsCompanyInformationId}`,
    );
    // ID が変わったなどがあっても、畳まれなくなる以上のことが起こらないように、単に return する
    if (companyInformation === null) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          setIsFolded(entry.isIntersecting);
        }
      },
      {
        rootMargin: '10000% 0px 0px 0px', // 上方向に大きくマージンをとっておくことでcompanyInformationが画面上に見えなくなっても交差扱いにすることができる
        threshold: [0, 0.2, 0.4, 0.6, 0.8, 1], // 高速でスクロールさせた時用に交差確認の頻度を増やしています
      },
    );
    observer.observe(companyInformation);

    // cleanup
    return () => {
      observer.unobserve(companyInformation);
    };
  }, []);

  return (
    <header
      className={styles.root}
      data-is-folded={isFolded}
      data-is-preview={isPreview}
    >
      <div
        className={clsx(
          styles.inner,
          isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
        )}
      >
        {children}
      </div>
    </header>
  );
}
